
import { Component, Vue } from 'vue-property-decorator'
@Component
export default class shopCarAnimation extends Vue {
  shopCarAnimation(e: Event, targetDom?: string) {
    if (!e) {
      return
    }
    let RectDom
    let shopCar
    if (targetDom) {
      // @ts-ignore
      RectDom = e.getBoundingClientRect()
      shopCar = document.querySelector(targetDom)
    } else {
      RectDom = (e.target as HTMLElement).getBoundingClientRect()
      shopCar = document.querySelector('.shopCarBox')
    }
    let shopCarLeft = 0
    if(shopCar) {
      console.log('true');
      let shopCarDom = shopCar.getBoundingClientRect()
      shopCarLeft = shopCarDom.left
    }
    let FTop = RectDom.top
    let FLeft = RectDom.left

    // let FBottom = RectDom.bottom
    // console.log('RectDom',RectDom);
    // 当前视口的高度
    let H = document.documentElement.clientHeight || document.body.clientHeight
    // 创建元素
    let div = document.createElement('div')
    div.className = 'shop-car-animation'
    div.innerHTML = '<div class="shop-car-animation-inner"></div>'
    // 元素定位到点击按钮的位置
    let left = FLeft
    let top = FTop
    // 距离购物车的宽度
    let x = -100
    if(shopCarLeft) {
      x = shopCarLeft - FLeft
    } else {
      let testx = document.querySelectorAll('.tab-fs-name')
      if (testx.length) {
        shopCarLeft = testx[testx.length - 1].getBoundingClientRect().left
        x = shopCarLeft - FLeft
      }
    }
    // 距离底部导航栏的高度
    let y = H - top - 60
    if (targetDom) {
      x = x + 15
      y = y + 10
    }
    // 动态添加属性值
    div.style.setProperty('--left', `${left}px`)
    div.style.setProperty('--top', `${top}px`)
    div.style.setProperty('--x', `${x}px`)
    div.style.setProperty('--y', `${y}px`)
    // 移除元素
    div.addEventListener('animationend', () => {
      div.remove()
    })
    document.body.appendChild(div)
  }
}
